/* eslint-disable */
$(document).ready(() => {
  const img_title = 'Автор отзыва записался на прием через ПроДокторов. После консультации оператор call-центра связался с ним, собрал обратную связь и опубликовал отзыв под диктовку. Запись телефонного разговора оператора call-центра ПроДокторов и автора отзыва сохранена.'
  const anonym_title = 'Отзывы неавторизованных пользователей не участвуют в рейтинге с 25.06.2019'

  $(document).on('mouseenter', '.appointment-throu', function () {
    $(this).attr('title', img_title)
  })
  $(document).on('mouseleave', '.appointment-throu, .anonym-rate', function () {
    $(this).attr('title', '')
  })

  $(document).on('mouseenter', '.anonym-rate', function () {
    $(this).attr('title', anonym_title)
  })
})
